import { apiRequest } from "./api";
import type {
  GigRequestMessageRequest,
  GigRequestMessageResponse,
} from "../types/gigTypes";

const listMessages = (basePath: string, requestId: string) =>
  apiRequest<GigRequestMessageResponse[]>(`${basePath}/gig-requests/${requestId}/messages`, {
    method: "GET",
  });

const sendMessage = (basePath: string, requestId: string, payload: GigRequestMessageRequest) =>
  apiRequest<GigRequestMessageResponse>(`${basePath}/gig-requests/${requestId}/messages`, {
    method: "POST",
    body: payload,
  });

export const teenGigRequestMessagesApi = {
  list(requestId: string): Promise<GigRequestMessageResponse[]> {
    return listMessages("/api/teen", requestId);
  },

  send(requestId: string, payload: GigRequestMessageRequest): Promise<GigRequestMessageResponse> {
    return sendMessage("/api/teen", requestId, payload);
  },
};

export const adultGigRequestMessagesApi = {
  list(requestId: string): Promise<GigRequestMessageResponse[]> {
    return listMessages("/api/adult", requestId);
  },

  send(requestId: string, payload: GigRequestMessageRequest): Promise<GigRequestMessageResponse> {
    return sendMessage("/api/adult", requestId, payload);
  },
};

export const guardianGigRequestMessagesApi = {
  list(requestId: string): Promise<GigRequestMessageResponse[]> {
    return listMessages("/api/adult/guardian", requestId);
  },
  send: undefined,
};
